import { render, staticRenderFns } from "./BalanceTabsItems.vue?vue&type=template&id=184b50ae&scoped=true"
import script from "./BalanceTabsItems.vue?vue&type=script&lang=js"
export * from "./BalanceTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b50ae",
  null
  
)

export default component.exports